<template>
  <div v-if="path === '/admin/mapa'">
    <div
      :class="{[$style.cui__sidebar]: true, [$style.cui__sidebar__toggled]: settings.isSidebarOpen}"
    >
      <vue-custom-scrollbar :style="{ height: '100%' }">
        <div :class="$style.cui__sidebar__inner">
          <a
            href="javascript: void(0);"
            :class="$style.cui__sidebar__close"
            class="fe fe-x-circle"
            @click="toggleSidebar()"
          />
          <h4 id="demo">
            <strong>Resumen</strong>
          </h4>
          <div class="cui__utils__line" :style="{ marginTop: '25px', marginBottom: '30px' }" />
          <div :class="$style.cui__sidebar__type" class="mb-4">
            <h5 :class="$style.cui__sidebar__type__title">
              <span>Conductores totales: {{ availableVehicles + ocupedVehicles + onTripVehicles }} </span>
            </h5>
            <span><strong>Estatus</strong></span>
            <div :class="$style.cui__sidebar__type__items">
              <span class="dot"></span><span>Disponibles: {{ availableVehicles }}</span>
            </div>
            <div :class="$style.cui__sidebar__type__items">
              <span>No disponibles: {{ ocupedVehicles }}</span>
            </div>
            <div :class="$style.cui__sidebar__type__items">
              <span>En Viaje: {{ onTripVehicles }}</span>
            </div>
          </div>
          <!-- <div :class="$style.cui__sidebar__type" class="mb-4">
            <div :class="$style.cui__sidebar__type__title">
              <span><strong>Tipo de vehículo:</strong></span>
              -->
              <!--
              <div v-for="(group, key) in groupedVehicles" :key="key">
                -->
                <!--
                <div :class="$style.cui__sidebar__type__items">
                  <span>Premium: {{ premiumVehicles }}</span>
                </div>
                <div :class="$style.cui__sidebar__type__items">
                  <span>Plus: {{ plusVehicles }}</span>
                </div>
                <div :class="$style.cui__sidebar__type__items">
                  <span>Normal: {{ normalVehicles }}</span>
                </div>
                -->
                <!--
                <span>{{ key }} : {{ group.length }}</span>
              </div>
                -->
            <!-- </div> -->
          <!-- </div> -->
        </div>
      </vue-custom-scrollbar>
    </div>
    <a-tooltip placement="left">
      <template slot="title">
        <span>Resumen de vehículos</span>
      </template>
      <a
        href="javascript: void(0);"
        @click="toggleSidebar()"
        style="bottom: calc(50% + 120px)"
        :class="$style.cui__sidebar__toggleButton"
      >
        <i class="fe fe-file-text" />
      </a>
    </a-tooltip>
  </div>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { mapState } from 'vuex'
import gql from 'graphql-tag'
import firebase from 'firebase'
import headers from '@/config/headers.js'
/*
// import { encrypt } from '@/config/headers'
const VEHICLE_QUERY = gql`
    query getTaxiCheckInByDriverId($id: Int!){
      getTaxiCheckInByDriverId(id: $id){
        id
        concesion{
          id
          vehicle{
            id
            vehicleType{
              id
              type
            }
          }
        }
      }
    }
` */
const GET_STATUS_DRIVERS = gql`
  query getDriversSummary{
    getDriversSummary{
      PorEstatus{
        Disponibles
        EnViaje
        NoDisponibles
      }
    }
  }
`
/*
const GET_STATUS_DRIVERS = gql`
  query getDriversSummary{
    getDriversSummary{
      PorEstatus{
        Disponibles
        EnViaje
        NoDisponibles
      }
      PorTipoDeVehiculo{
        Plus
        Premium
        Normal
      }
    }
  }
`
*/
export default {
  components: { vueCustomScrollbar /* AirColorPicker */ },
  computed: {
    ...mapState(['settings']),
    primaryColor() {
      return this.settings.primaryColor
    },
    groupedVehicles() {
      return this.groupBy(this.vehiclesByType)
    },
  },
  data() {
    return {
      hoy: new Date(),
      secs: '0',
      newsecs: '0',
      defaultColor: '#c51616',
      availableVehicles: '0',
      ocupedVehicles: '0',
      onTripVehicles: '0',
      premiumVehicles: '0',
      plusVehicles: '0',
      normalVehicles: '0',
      vehiclesByType: [],
      tDrivers: '0',
      path: this.$route.path,
      unsubscribe: null,
      getVehicles: [],
    }
  },
  apollo: {
    /*
    getStatusDrivers: {
      query: GET_STATUS_DRIVERS,
      context: headers(),
      result({ data }) {
        this.$apollo.query({ query: GET_STATUS_DRIVERS, context: headers() })
          .then(({ data }) => {
            console.log(data.getDriversSummary, 'st')
            this.drivers = data.getDriversSummary.PorEstatus.Disponibles + data.getDriversSummary.PorEstatus.NoDisponibles + data.getDriversSummary.PorEstatus.EnViaje
            this.availableVehicles = data.getDriversSummary.PorEstatus.Disponibles
            this.ocupedVehicles = data.getDriversSummary.PorEstatus.NoDisponibles
            this.onTripVehicles = data.getDriversSummary.PorEstatus.EnViaje
            // this.premiumVehicles = data.getDriversSummary.PorTipoDeVehiculo.Premium
            // this.plusVehicles = data.getDriversSummary.PorTipoDeVehiculo.Plus
            // this.normalVehicles = data.getDriversSummary.PorTipoDeVehiculo.Normal
          })
          .catch(error => {
            console.log(error)
          })
      },
    },
    */
  },
  async mounted() {
    this.hoy.valueOf()
    var urlmapa = window.location.href
    var urlmapalength = urlmapa.length
    var cuttedurl = urlmapa.slice(urlmapalength - 4, urlmapalength)
    console.log(cuttedurl, 'url')
    if (cuttedurl === 'mapa') {
      // this.getDrivers()
      await this.getDriverStatus()
      const drivers = await firebase.firestore().collection('drivers').get()
      drivers.docs.forEach(document => {
        // this.getDriverStatus()
        // this.tDrivers = drivers.docs
        const driver = document.data()
        // // console.log(driver)
        // const id = driver.driver.id
        // if (driver.active) {
        //   this.availableVehicles[id] = driver
        // } else if (!driver.active) {
        //   this.ocupedVehicles[id] = driver
        // } else if (driver.onTrip) {
        //   this.onTripVehicles[id] = driver
        // }
        if (driver.vehicle) {
          // console.log(driver.vehicle)
          this.vehiclesByType.push(driver)
        }
        /*
        this.$apollo.query({
          query: VEHICLE_QUERY,
          variables: {
            id: position.driverId,
          },
          context: {
            // headers: encrypt(new Date().getTime()),
          },
        })
          .then(result => {
            const vehicleType = result.data.getTaxiCheckInByDriverId.concesion.vehicle.vehicleType
            this.vehiclesByType.push(vehicleType)
          })
          .catch(error => {
            console.log(error)
          })  */
      })
      this.unsubscribe = firebase.firestore().collection('drivers').onSnapshot(snapshot => {
        if (snapshot.docChanges()[0].type === 'modified') {
          snapshot.docChanges().forEach(document => {
            // const driver = document
            this.newsecs = new Date().valueOf()
            this.newsecs = this.newsecs.toString().slice(0, 10)
            this.newsecs = parseInt(this.newsecs)
            console.log(this.newsecs, 'newsecs')
            var diferenceSecs = parseInt(this.newsecs - this.secs)
            console.log(diferenceSecs, 'dife')
            console.log(this.secs, '>', this.newsecs)
            if (diferenceSecs >= 5) {
              this.getDriverStatus()
              this.secs = this.newsecs
              // this.newsecs = this.hoy.getSeconds()
            }
          })
        } else if (snapshot.docChanges()[0].type === 'added') {
          snapshot.docChanges().forEach(document => {
            // const driver = document
            this.newsecs = new Date().valueOf()
            this.newsecs = this.newsecs.toString().slice(0, 10)
            this.newsecs = parseInt(this.newsecs)
            console.log(this.newsecs, 'newsecs')
            var diferenceSecs = parseInt(this.newsecs - this.secs)
            console.log(diferenceSecs, 'dife')
            console.log(this.secs, '>', this.newsecs)
            if (diferenceSecs >= 5) {
              this.getDriverStatus()
              this.secs = this.newsecs
              // this.newsecs = this.hoy.getSeconds()
            }
            // this.getDriverStatus()
            // console.log(snapshot.docChanges())
          })
        }
      })
      console.log(this.unsubscribe, 'uns')
    }
    /*
    console.log('available')
    console.log(this.availableVehicles)
    console.log('ocuped')
    console.log(this.ocupedVehicles)  */
  /*
    const status = await firebase.firestore().collection('status').get()
    status.docs.forEach(document => {
      const vehicle = document.data()
      const id = document.id

      if (vehicle.status === 0) {
        this.availableVehicles[id] = vehicle
      } else {
        this.ocupedVehicles[id] = vehicle
      }
    })

    firebase.firestore().collection('status').onSnapshot(snapshot => {
      if (snapshot.docChanges()[0].type === 'modified') {
        snapshot.docChanges().forEach(document => {
          const id = document.doc.id
          const vehicle = document.doc.data()
          if (vehicle.status === 0) {
            if (!this.availableVehicles[id]) {
              this.ocupedVehicles.splice(id, 1)
              this.availableVehicles[id] = vehicle
            }
          } else {
            if (!this.ocupedVehicles[id]) {
              this.availableVehicles.splice(id, 1)
              this.ocupedVehicles[id] = vehicle
            }
          }
        })
      } else if (snapshot.docChanges()[0].type === 'added') {
        snapshot.docChanges().forEach(document => {
          const id = document.doc.id
          const vehicle = document.doc.data()
          if (vehicle.status === 0) {
            this.availableVehicles[id] = status
          } else {
            this.ocupedVehicles[id] = status
          }
        })
      }
    })
    */
  },
  // apollo: {
  // },
  methods: {
    toggleSidebar: function () {
      const setting = 'isSidebarOpen'
      const value = !this.settings[setting]
      if (value === false) {
        this.unsubscribe()
      }
      this.$store.commit('CHANGE_SETTING', { setting, value })
    },
    groupBy: function (arr) {
      return arr.reduce(function(memo, x) {
        if (x.vehicle) {
          // console.log(x.vehicle)
          if (!memo[x.vehicle.vehicleType.type]) { memo[x.vehicle.vehicleType.type] = [] }
          memo[x.vehicle.vehicleType.type].push(x)
          return memo
        }
      }, {})
    },
    getDriverStatus() {
      // console.log(driver)
      this.$apollo.query({ query: GET_STATUS_DRIVERS, context: headers() })
        .then(({ data }) => {
          console.log(data.getDriversSummary, 'conf')
          this.drivers = data.getDriversSummary.PorEstatus.Disponibles + data.getDriversSummary.PorEstatus.NoDisponibles + data.getDriversSummary.PorEstatus.EnViaje
          this.availableVehicles = data.getDriversSummary.PorEstatus.Disponibles
          this.ocupedVehicles = data.getDriversSummary.PorEstatus.NoDisponibles
          this.onTripVehicles = data.getDriversSummary.PorEstatus.EnViaje
          // this.premiumVehicles = data.getDriversSummary.PorTipoDeVehiculo.Premium
          // this.plusVehicles = data.getDriversSummary.PorTipoDeVehiculo.Plus
          // this.normalVehicles = data.getDriversSummary.PorTipoDeVehiculo.Normal
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss" module>
.dot {
  height: 10px;
  width: 10px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
}
@import "./style.module.scss";
</style>
